<template>
  <div class="dialog">
    <el-dialog
      class="formExportAis"
      :visible.sync="changVisible"
      :modal="false"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="true"
      :before-close="$onClose"
      :destroy-on-close="true"
    >
      <el-form id="form_downloadActivation" method="post"> </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { URL_PATH } from "@/config/config";
import * as CApi from "@/api/constant_api.js";

export default {
  data() {
    return {
      changVisible: false,
      loading: true,
      token: localStorage.getItem("token"),
      logIds: "",
    };
  },
  methods: {
    $onClose(done) {
      done();
    },
    close() {
      this.changVisible = false;
    },
    //页面初始化时加载的事件
    show(filter, screen_member_type, screen_result) {
      console.log(filter.where_uid);
      this.changVisible = true;
      let params = "?token=" + this.token;

      if (filter && filter.where_name != "") {
        params += "&where_name=" + filter.where_name;
      }
      if (filter && filter.where_student_no != "") {
        params += "&where_student_no=" + filter.where_student_no;
      }
      if (filter && filter.uid != "") {
        params += "&where_uid=" + filter.where_uid;
      }
      if (screen_member_type && screen_member_type != "") {
        params += "&screen_member_type=" + screen_member_type;
      }
      if (screen_result && screen_result != "") {
        params += "&screen_result=" + screen_result;
      }

      this.$nextTick(() => {
        const from = document.getElementById("form_downloadActivation");
        from.action = URL_PATH + CApi.api_exportActivationList + params;
        from.submit();
        this.close();
      });
    },
  },
};
</script>

<style lang="less" scoped>
.formExportAis {
  visibility: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/exportActivation.vue